<template>
  <div id="CitationPopUp" class="fixed top-0 left-0 w-full h-full bg-white bg-opacity-80">
    <div class="fixed top-1/4 left-1/3 w-1/3 h-auto bg-white border border-gray-300 rounded">
      <div class="m-5 text-2xl text-gray-900">Cite:</div>
      <div class="m-5 block border border-gray-300 h-12">Dummy Text</div>
      <button class="m-5 float-right p-2 bg-gray-300 rounded" @click="$emit('close')">Save</button>
    </div>
  </div>
</template>
